<template>
  <div class="login-wrapper">
    <div class="logo-container">
      <svg width="120" height="41" viewBox="0 0 120 41" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M115.78 17.266L111.241 12.7341H104.904V19.7556H108.753V32.556H104.315V39.5775H119.939V32.556H115.78V17.266Z" fill="#00C962"/>
        <path d="M87.9724 5.01275C87.9724 2.69588 89.8902 0.824219 92.165 0.824219C94.4398 0.824219 96.402 2.69588 96.402 5.01275C96.402 7.32962 94.5285 9.20128 92.165 9.20128C89.8016 9.20128 87.9724 7.32962 87.9724 5.01275Z" fill="white"/>
        <path d="M83.4912 12.7542H73.8311L68.1442 20.5265L62.455 12.7542H52.9036L63.1002 26.5845L52.7949 39.5576H62.5082L68.1974 32.2681L73.8866 39.5576H83.5444L73.2946 26.5845L83.4912 12.7542Z" fill="white"/>
        <path d="M86.1521 12.7542V19.7756H89.6618V32.5361H86.1521V39.5576H96.6924V12.7542H86.1521Z" fill="white"/>
        <path d="M39.7207 12.7541V15.4342C38.6476 13.9856 36.0181 12.1649 32.4219 12.1649C25.3913 12.1649 19.9727 18.5441 19.9727 26.157C19.9727 33.7698 25.3936 40.149 32.4219 40.149C36.0181 40.149 38.6476 38.3261 39.7207 36.8797V39.5598H50.1878V32.5361H46.6781V19.7778H50.1878V12.7541H39.7207ZM34.2488 32.8041C30.5994 32.8041 28.1317 30.0177 28.1317 26.157C28.1317 22.2962 30.5994 19.5076 34.2488 19.5076C37.8982 19.5076 40.3659 22.2962 40.3659 26.1547C40.3659 30.0132 37.8982 32.8041 34.2488 32.8041Z" fill="white"/>
        <path d="M12.022 5.9032H4.99368V12.7541H0.333252V19.7756H4.99368L4.99811 31.1739C4.99811 36.1288 8.59209 39.9231 13.5141 39.9231C15.9087 39.9231 17.0505 39.6684 17.5183 39.5643V33.0212C17.2655 33.0567 16.2168 33.1497 15.2457 33.0921C14.4986 33.0456 13.8888 32.937 13.4099 32.6358C12.4632 32.04 12.0242 30.8683 12.0242 29.1782V19.7756H18.1125V12.7541H12.0242V5.9032H12.022Z" fill="white"/>
      </svg>
    </div>
    <div class="card p-3">
    <div class="card-body">
      <h5 class="card-title text-center mb-4">Welcome to the Taxi1 admin portal</h5>
      <form @submit.prevent="login">
        <div class="mb-3">
          <label for="driverId" class="form-label">Username</label>
          <input class="form-control" type="text" required v-model="user.driverId.value" autocomplete="username">
          <span class="validate-error" v-if="user.driverId.showError">{{ user.driverId.errormsg }}</span>
        </div>
        <div class="mb-3">
          <label for="password" class="form-label">Password</label>
          <div class="input-group">
            <input :type="showPassword ? 'text' : 'password'" id="password" v-model="user.password.value" class="form-control" autocomplete="new-password" />
            <button @click.prevent="toggleShowPassword" class="btn btn-outline-primary" type="button">
              {{ showPassword ? 'Hide' : 'Show' }}
            </button>
          </div>
          <span class="validate-error" v-if="user.password.showError">{{ user.password.errormsg }}</span>
        </div>
        <button type="submit" class="btn btn-success">Login</button>
      </form>
    </div>
  </div>
</div>
</template>

<script>
import axios from 'axios';
import Swal from 'sweetalert2';

export default {
data() {
  return {
    user: {
      driverId: {
        value: '',
        errormsg: 'Driver ID is required',
        showError: false
      },
      password: {
        value: '',
        errormsg: 'Password must be at least 7 characters',
        showError: false
      }
    },
    showPassword: false,
  };
},
methods: {
  async login() {
    this.user.driverId.showError = false;
    this.user.password.showError = false;

    if (!this.user.password.value || this.user.password.value.length < 6) {
      this.user.password.errormsg = 'Password must be at least 7 characters';
      this.user.password.showError = true;
    } else {
      this.user.password.errormsg = '';
    }

    if (!this.user.driverId.value) {
      this.user.driverId.errormsg = 'Username is required';
      this.user.driverId.showError = true;
    } else {
      this.user.driverId.errormsg = '';
    }

    if (!this.user.driverId.showError && !this.user.password.showError) {
      console.log(process.env.VUE_APP_PUBLIC_PATH); // 输出路径以进行调试
      try {
        const response = await axios.post(`${process.env.VUE_APP_PUBLIC_PATH}/api/admin/login`, {
          username: this.user.driverId.value,
          password: this.user.password.value,
        });

        console.log('API response:', response); // 调试信息

        const token = response.data.token;
        const role_id = response.data.admin.role_id;
        if (token) {
          localStorage.setItem('adminToken', token);
          localStorage.setItem('Admin', JSON.stringify({ username: this.user.driverId.value, role: 'admin', role_id: role_id }));
          this.$router.push('/admin/home');
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Login Failed',
            text: 'Invalid credentials, please try again!',
          });
        }
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'Login Error',
          text: 'An error occurred while trying to login. Please try again later.',
        });
      }
    }
  },
  toggleShowPassword() {
    this.showPassword = !this.showPassword;
  },
},
};
</script>

<style scoped>
.login-wrapper {
position: relative;
height: 100vh;
background-image: url('../../assets/images/login/login_background.jpeg'); /* 背景图片路径 */
background-size: cover;
background-position: center;
display: flex;
justify-content: center;
align-items: center;
}

.logo-container {
position: absolute;
top: 20px;
left: 20px;
}

.login-card {
padding: 50px;
}

.validate-error {
color: red;
font-size: 0.8em;
}
</style>
